export const buildCheckoutRedirectUrl = ({
  checkoutUrl,
  locationSearch = '',
  anonymousId = '',
  customerEmail = '',
}) => {
  if (!checkoutUrl) {
    return null;
  }

  const url = checkoutUrl.split('?')?.[0];
  const search = locationSearch.split('?')?.[1] || '';
  const initialParams = (search && `&${search}`) || '';
  const anonymousIdParam =
    (anonymousId && `&segmentAnonymousId=${anonymousId}`) || '';
  const checkoutEmailParam =
    (customerEmail &&
      `&checkout[email]=${encodeURIComponent(customerEmail)}`) ||
    '';
  const queryParams =
    checkoutUrl.split('?')?.[1] +
    initialParams +
    anonymousIdParam +
    checkoutEmailParam;

  return `${url}?${queryParams}`;
};
